import React from 'react';
import AbstractView from '@src/components/_views/AbstractView';
import OrderForm from '@views/dashboard/manager/OrderForm';
import cacheableAccessor from '@src/helpers/cacheableAccessor';
import ProductionDashboard from '@views/dashboard/ProductionDashboard';
import getUri from '@src/helpers/getUri';
import {EndpointUri} from '@src/@types/EndpointUri';

const getPageBreadcrumbs = cacheableAccessor(() => [
    {
        label: ProductionDashboard.pageTitle,
        uri: getUri('dashboards@manager'),
    },
    {
        label: OrderPage.pageTitle,
        uri: {route: 'dashboards@manager-order-page'} as EndpointUri,
    }
]);

export default class OrderPage extends AbstractView {
    static pageTitle = 'Dashboards:Manager.order-page.page-title';

    protected renderContent() {
        return <OrderForm
                pageTitle={this.getPageTitle()}
                pageBreadcrumbs={this.getPageBreadcrumbs()}
        />;
    }

    protected getPageBreadcrumbs(): React.ComponentProps<typeof OrderForm>['pageBreadcrumbs'] {
        return getPageBreadcrumbs();
    }
}
